import debug from 'debug';
import { Router } from 'react-router-dom';

const debugRouter = debug('readme:router');

/**
 * A drop-in replacement for `react-router-dom`'s `Router` that
 * logs `debug` statements to your browser console.
 */
class DebugRouter extends Router {
  constructor(props) {
    super(props);
    debugRouter('initial BrowserRouter props:', props);
    debugRouter('initial history', props.history);
    props.history.listen((location, action) => {
      debugRouter(`The current URL is ${location.pathname}${location.search}${location.hash}`);
      debugRouter(`The last navigation action was ${action}`, props.history);
    });
  }
}

export default DebugRouter;
